import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, Typography } from "@mui/material";
import ModalContainer from "components/ModalContainer";
import ModalLayout from "components/ModalLayout";

const useStyles = makeStyles((theme) => ({
  modalConatiner: {
    height: "60%",
    width: "100%",
    margin: "5px",
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "start",
    alignItems: "center",
    gap: 12
  },
  header: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    alignItems: "center",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));

const ViewImageModal = ({
  isOpen,
  label,
  imageSource,
  close,
  hasPadding = true,
  customStyle,
}) => {
  const styles = useStyles();

  return (
    isOpen && (
      <ModalContainer openModel={isOpen} handleClose={close}>
        <ModalLayout isLargeContainer={false} hasPadding={hasPadding}>
          <Box className={styles.modalConatiner}>
            <Typography style={{ fontWeight: 'bold'}}>{label}</Typography>
            <Box style={{ ...customStyle }}>
              <img
                className={styles.image}
                src={imageSource}
                alt={label + " "}
              />
            </Box>
          </Box>
        </ModalLayout>
      </ModalContainer>
    )
  );
};

export default ViewImageModal;
